import React, { Component } from 'react'
import moment from 'moment'

const Info = props => {
    let { pathname, subscribeData } = props
    let {
        dapp_address,
        dapp_name,
        subscription_description,
        subscription_name,
        subscription_free_time,
        subscription_period_price,
        subscription_period_type,
        subscription_period_value,
    } = subscribeData
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    return (
        <div className="subscribe__box subscribe__box_left">
            <div>
                <h2 className="subscribe__desc subscribe__desc_blue subscribe__text-size_m subscribe__margin-bottom_m">
                    {`Depository.${pathname.slice(0,1).toUpperCase()}${pathname.slice(1)}`}
                </h2>
                <p className="subscribe__text-size_x">{dapp_name}</p>
                <p className="subscribe__desc subscribe__margin-bottom_s subscribe__text-ofh">
                    {dapp_address}
                </p>
                <p className="subscribe__text-size_m">{subscription_name}</p>
                <p className="subscribe__desc subscribe__margin-bottom_s">
                    {`${subscription_period_price} CPT per ${subscription_period_value} ${subscription_period_type}`}
                </p>
                <p className="subscribe__desc">{`${translation['Description']}:`}</p>
                <p className="subscribe__desc subscribe__margin-bottom_s">
                    {subscription_description}
                </p>
                {subscription_free_time > 0 ? (
                    <React.Fragment>
                        <p className="subscribe__desc">{`${freeTrialDate(
                            subscription_free_time
                        )} free trial`}</p>
                        <p className="subscribe__desc subscribe__margin-bottom_x subscribe__desc_mw40">
                            You can cancel your subscription any time before the
                            end of your free trial. You will not receive a
                            notice that your free trial is about to end or has
                            ended, or that your paid subscription has begun.
                        </p>
                    </React.Fragment>
                ) : null}
            </div>
        </div>
    )
}

const freeTrialDate = sec => {
    let seconds = parseInt(sec, 10)

    let days = Math.floor(seconds / (3600 * 24))
    seconds -= days * 3600 * 24
    let hrs = Math.floor(seconds / 3600)
    seconds -= hrs * 3600
    let mnts = Math.floor(seconds / 60)
    seconds -= mnts * 60

    let resultDate = [days, hrs, mnts, seconds]

    resultDate = resultDate.map((item, i) => {
        let timeUnits = ['d', 'hr', 'min', 'sec']
        if(item > 0) {
            return `${item}${timeUnits[i]}`
        }
    })

    return(resultDate.join(' '))
}

export default Info
